import * as React from "react";
const SvgBudget = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
    <path fill="#fff" d="M0 0h40v40H0z" opacity={0.01} />
    <path
      stroke="#191919"
      strokeWidth={1.5}
      d="M10.833 12.834a2 2 0 0 1 2-2h14.333a2 2 0 0 1 2 2v14.333a2 2 0 0 1-2 2H12.833a2 2 0 0 1-2-2z"
      clipRule="evenodd"
    />
    <rect width={1.667} height={1.667} x={14.167} y={15.834} fill="#191919" rx={0.833} />
    <rect width={9.167} height={1.25} x={16.667} y={15.834} fill="#191919" rx={0.625} />
    <rect width={1.667} height={1.667} x={14.167} y={19.166} fill="#191919" rx={0.833} />
    <rect width={9.167} height={1.25} x={16.667} y={19.166} fill="#191919" rx={0.625} />
    <rect width={1.667} height={1.667} x={14.167} y={22.5} fill="#191919" rx={0.833} />
    <rect width={9.167} height={1.25} x={16.667} y={22.5} fill="#191919" rx={0.625} />
  </svg>
);
export default SvgBudget;
